import { useQuery } from '@tanstack/react-query';

import { SCHEDULED_ORDER_DETAIL_STALE_TIME_MS } from '../domain';
import { scheduleOrderAdapter } from '../infra/adapters';
import { scheduleOrderService, scheduleQueryKeys } from '../infra/services';

export function useScheduledOrderDetailQuery(orderId: number | null) {
  return useQuery({
    queryKey: scheduleQueryKeys.detail(orderId!),
    queryFn: () => scheduleOrderService.getScheduledOrderDetail(orderId!),
    select: scheduleOrderAdapter.toScheduledOrderDetail,
    enabled: orderId !== null,
    staleTime: SCHEDULED_ORDER_DETAIL_STALE_TIME_MS,
  });
}
